import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const wrap = (theme: Theme) => css`
  background-color: ${`${theme.palette.primary.maxContrast}0A`};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${size[24]};
  padding-block: ${size[60]};

  ${breakpoint.up('md')} {
    flex-direction: row;
    padding: 0;
  }
`

export const text = css`
  max-width: ${width.container.standard};

  ${breakpoint.up('md')} {
    padding: ${size[16]};
  }
`

export const title = css`
  font-weight: 700;
  font-size: ${pxToRem(24)};
  max-width: 550px;
  margin-bottom: ${size[32]};
  text-align: center;
  padding-inline: ${size[20]};

  ${breakpoint.up('md')} {
    text-align: start;
    padding: 0;
    font-size: ${pxToRem(38)};
  }
`

export const desc = (theme: Theme) => css`
  color: ${theme.palette.text.title};
  font-weight: 400;
  font-size: ${pxToRem(18)};
  line-height: ${pxToRem(32)};
  margin: ${size[32]};
  margin-bottom: 0;

  ${breakpoint.up('md')} {
    margin: 0;
    line-height: ${pxToRem(34)};
  }
`

export const img = css`
  margin-inline: 20px;
  width: 100%;

  ${breakpoint.up('md')} {
    margin: 0;
    width: 550px;
    height: 550px;
  }
`
